var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 17.4792L5.22917 10.4792C5.14583 10.3958 5.08694 10.3056 5.0525 10.2083C5.0175 10.1111 5 10.0069 5 9.89583C5 9.78472 5.0175 9.68056 5.0525 9.58333C5.08694 9.48611 5.14583 9.39583 5.22917 9.3125L12.25 2.29167C12.4444 2.09722 12.6875 2 12.9792 2C13.2708 2 13.5208 2.10417 13.7292 2.3125C13.9375 2.52083 14.0417 2.76389 14.0417 3.04167C14.0417 3.31944 13.9375 3.5625 13.7292 3.77083L7.60417 9.89583L13.7292 16.0208C13.9236 16.2153 14.0208 16.4547 14.0208 16.7392C14.0208 17.0242 13.9167 17.2708 13.7083 17.4792C13.5 17.6875 13.2569 17.7917 12.9792 17.7917C12.7014 17.7917 12.4583 17.6875 12.25 17.4792Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIPhone);
export default __webpack_public_path__ + "static/media/Arrow-iPhone.098fd6d063cbd362c13c2f4c37152812.svg";
export { ForwardRef as ReactComponent };